import { Injectable } from '@angular/core';
import { SsbConfig } from '@features/ssb-konfiguration/ssb-config.model';
import { RestApi } from '@core/api/rest.api';

@Injectable({
  providedIn: 'root'
})
export class StmPropertyApi extends RestApi<SsbConfig> {
  override endpoint = '/api/admin/stmproperty';
}
